import React, { useEffect, useState } from "react";
import Head from "next/head";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Link from "next/link";
import Footer from "../component/footer";

export default function Custom404() {
  return (
    <>
      <Head>
        <title>404 - Page Not Found</title>
        <link rel="canonical" href="https://abodefinder.com.au/404/"></link>
        <meta name="description" content="description" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/png" sizes="32x32" href="https://abodefinder.com.au/blog-static/img/favicon-32.ico"/>
      </Head>
      <div className="not-background">
        <Card
          sx={(theme) => ({
            width: "40%",
            border: "2px solid var(--primary-color)",
            p: 5,
            textAlign: "center",
            [theme.breakpoints.down("sm")]: { width: "90%", mt: 1 },
          })}
        >
          <Typography
            variant="h4"
            gutterBottom
            sx={{ color: "var(--primary-color)", fontWeight: "600" }}
          >
            404 - Page Not Found
          </Typography>
          <Typography variant="h6" gutterBottom>
            The page you are looking for does not exist.
          </Typography>
          <Link href="/">Go back to the homepage</Link>
        </Card>
      </div>
      <Footer />
    </>
  );
}
